import MMatchCardRow from './MMatchCardRow.vue';

export { MMatchCardRow };
export default MMatchCardRow;
